import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Import i18n configuration
import './i18n/i18n'
// Catch the browser's install prompt whichever page it fires on
import './hooks/useInstallApp'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)